module.exports = __webpack_public_path__ + "static/media/6.59ddf01e.jpg";